import React, { useState, useEffect } from "react";
import { Tag, TableFooter, Table, Typography } from "components";
import { terminalStatuses } from "utils/constants";
import {
  formatUrlQuery,
  formatFilterPayload,
  // capitalizeFirstLetter,
} from "utils/helper";
import { routes } from "routes/apiRoutes";
import makeRequest from "services/makeRequest";

const AgentTerminals = (props) => {
  const initialFilterState = {
    sort: false,
    number: 1,
    startDate: "",
    agentId: props.agentId,
    // endDate: "",
    // status: "",
    // oem: "",
    size: 10,
  };

  const [filterState, setFilterState] = useState(initialFilterState);

  const [data, setData] = useState({
    terminals: null,
    loading: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterState({ ...filterState, [name]: value });
  };

  const getTerminalsData = (queryParams) =>
    makeRequest("get", routes.fetchTerminals(queryParams));

  const loadTerminals = async (
    queryParams = formatUrlQuery(formatFilterPayload(filterState))
  ) => {
    setData({ ...data, loading: true });
    try {
      const res = await getTerminalsData(queryParams);
      setData((prev) => ({
        ...prev,
        terminals: res.data.data,
        loading: false,
      }));
    } catch (err) {
      console.log(err);
      setData({ ...data, loading: false });
    }
  };

  useEffect(() => {
    loadTerminals();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterState.number, filterState.size, filterState.sort]);

  const getStatusTag = (value) => {
    let terminal = terminalStatuses.find((status) => status.mapper === value);

    const { text, bgColor, color } = terminal || {};

    return terminal ? (
      <Tag text={text} backgroundColor={bgColor} textColor={color} />
    ) : (
      value
    );
  };

  const columns = [
    {
      Header: "S/N",
      Cell: (row) => Number(row.row.id) + 1,
    },
    {
      Header: "OEM Name",
      accessor: "oem",
    },
    {
      Header: "Terminal ID",
      accessor: "terminalId",
    },
    {
      Header: "Serial Number",
      accessor: "serialNumber",
    },
    {
      Header: "IMEI",
      accessor: "imei",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => (
        <div className="d-flex justify-content-center">
          {getStatusTag(props.value)}
        </div>
      ),
    },
  ];

  return (
    <div>
      <Typography state="primary" className="mb-3" variant="subtitle3">
        Assigned Terminals
      </Typography>
      <Table
        columns={columns}
        data={data.terminals?.content}
        centerData
        loading={data.loading}
      />
      {data.terminals?.content?.length ? (
        <TableFooter
          pageSize={filterState.size}
          handleChange={handleChange}
          availableDataLength={data.terminals.content.length}
          totalDataLength={data.terminals.totalElements}
          handlePageClick={(pageNo) =>
            setFilterState({ ...filterState, number: pageNo })
          }
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default AgentTerminals;
